module.exports = __webpack_public_path__ + "img/1-4.81dd0b27.png";